import { render, staticRenderFns } from "./ModalAgregarProductoRegenera.vue?vue&type=template&id=ba225168&scoped=true"
import script from "./ModalAgregarProductoRegenera.vue?vue&type=script&lang=js"
export * from "./ModalAgregarProductoRegenera.vue?vue&type=script&lang=js"
import style0 from "./ModalAgregarProductoRegenera.vue?vue&type=style&index=0&id=ba225168&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba225168",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba225168')) {
      api.createRecord('ba225168', component.options)
    } else {
      api.reload('ba225168', component.options)
    }
    module.hot.accept("./ModalAgregarProductoRegenera.vue?vue&type=template&id=ba225168&scoped=true", function () {
      api.rerender('ba225168', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/BussinessAndBranch/ModalAgregarProductoRegenera.vue"
export default component.exports